// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__28WGb","label":"Radio_label__1RvYq","checkMark":"Radio_checkMark__2AvOD","disabled":"Radio_disabled__2NiC7"};